import { HttpErrorResponse } from '@angular/common/http';

export function formatHttpErrorMessage(
  err: unknown,
  fallback = 'Не удалось выполнить операцию'
): string {
  if (err == null) {
    return fallback;
  }
  if (typeof err === 'string') {
    return err.trim() || fallback;
  }

  const httpErr = err as HttpErrorResponse;
  const body = httpErr.error ?? err;

  if (typeof body === 'string') {
    const text = body.trim();
    return text || fallback;
  }

  if (body && typeof body === 'object') {
    const o = body as Record<string, unknown>;

    if (Array.isArray(o.Errors)) {
      const parts = o.Errors.map((e) => {
        if (e && typeof e === 'object' && 'Message' in e) {
          return String((e as { Message: unknown }).Message);
        }
        return String(e);
      }).filter(Boolean);
      if (parts.length) {
        return parts.join('\n');
      }
    }

    if (typeof o.Error === 'string' && o.Error.trim()) {
      return o.Error.trim();
    }
    if (typeof o.Message === 'string' && o.Message.trim()) {
      return o.Message.trim();
    }
    if (typeof o.detail === 'string' && o.detail.trim()) {
      return o.detail.trim();
    }
    if (typeof o.title === 'string' && o.title.trim()) {
      return o.title.trim();
    }

    const validationErrors = o.errors;
    if (validationErrors && typeof validationErrors === 'object') {
      const parts: string[] = [];
      for (const value of Object.values(validationErrors as Record<string, unknown>)) {
        if (Array.isArray(value)) {
          parts.push(...value.map(String));
        } else if (value != null) {
          parts.push(String(value));
        }
      }
      if (parts.length) {
        return parts.join('\n');
      }
    }
  }

  if (httpErr.statusText) {
    return httpErr.statusText;
  }
  if (httpErr.status) {
    return `Ошибка ${httpErr.status}`;
  }

  return fallback;
}
